import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

export default class PostCancelRoute extends Route {
  @service analytics!: AnalyticsService;

  activate() {
    this.analytics.track('account', 'canceled_state_viewed');
  }
}
